import { reactive, readonly } from 'vue'

const state = reactive({
  enabled: false,
  targetLang: null, // e.g. 'en' | 'ru' | 'he'
})

export function useMenuTranslateState() {
  return state
}

export function useMenuTranslateStateReadonly() {
  return readonly(state)
}
